

import $ from 'jquery';
import { dom } from './dom';
import isVideoAutoplaySupported from './is-video-autoplay-supported';

const JS_PREFIX = 'js-hero';

export default {
  dom: {
    $el: null,
    $videoHolder: null
  },
  initVideo() {
    this.dom.$videoHolder = this.dom.$el.find(`#${JS_PREFIX}__video-holder`);

    if(this.dom.$videoHolder.length) {
      dom.waitForVisibility(this.dom.$videoHolder[0]).then(res => {
        // If autoplay is supported, show video
        isVideoAutoplaySupported(supported => {
          const $video = $(this.dom.$videoHolder.data('video-html'));

          // Show the video when playing starts
          $video.on('play', function () {
            $video.addClass('is-playing');
          });

          this.dom.$videoHolder.html($video);
        });
      })
    }
  },
  init() {
    this.dom.$el = $(`#${JS_PREFIX}`);

    if(!this.dom.$el.length) {
      return;
    }

    this.initVideo();
  }
}
